import { MainContainer } from 'components/page/containers/MainContainer'
import { useAuth } from 'pages/auth/hooks/useAuth'
import { useOnboarding } from 'pages/onboarding/hooks/useOnboarding'
import { StyledEditProfileWrapper, StyledFilterIcon } from 'pages/profile/styled'
import { useScreenSizes } from 'hooks/use-screen-sizes/useScreenSizes'
import { observer } from 'mobx-react'
import { NotificationItem } from '../NotificationItem'
import { Switch } from 'common/atoms/Switch/Switch'
import { SwitchDesignModes } from 'common/atoms/Switch/Switch.types'
import { useEffect, useState } from 'react'
import { usePreference } from 'pages/preferences/hooks/usePreference'
import { NotificationsPage } from 'pages/profile/NotificationsPage'
import EditProfileDrawer from './EditProfileDrawer'
import { NotificationType } from 'common/types/preference.types'
import { notify } from 'hooks/use-notification/useNotification'
import { NotificationsGroupItemName } from 'common/types/account-settings-drawer.types'


const EditNotificationsPage = () => {
  const { backendUser } = useAuth()
  const { isDevice } = useScreenSizes()
  const { inviteUsersByEmail } = useOnboarding()
  const {
    createUserNotification,
    notificationTypes,
    userNotificationPreferences,
    getAllUserNotificationPreferences,
    notificationsPreference,
    setNotificationsPreference,
  } = usePreference('member')
  const [disableOnResponse, setDisableOnResponse] = useState<{
    events: boolean;
    tutorials: boolean;
    connections: boolean;
    engagement: boolean;
  }>({
    events: false,
    tutorials: false,
    connections: false,
    engagement: false
  });
  const getEmailOptionAnswer = (notificationType: NotificationType) => {
    const response = userNotificationPreferences?.find((preference) => preference?.notificationTypeId === notificationType?.id)    
    return response?.emailNotifications 
  }

  const handleNotificationSwitch = async (e: boolean, notificationTypeId: NotificationType) => {
    try {
      setDisableOnResponse((prevDisableOnResponse) => ({
        ...prevDisableOnResponse,
        [notificationTypeId.notificationType]: true,
      }));
      const getCurrentNotification = await userNotificationPreferences.find(preference => preference.notificationTypeId === notificationTypeId.id)
      const updatedNotificationsPreference = { ...getCurrentNotification, userId: backendUser.id, notificationTypeId: notificationTypeId.id, emailNotifications: e };
      await createUserNotification(updatedNotificationsPreference)
      setNotificationsPreference(updatedNotificationsPreference)
      notify("success", "Notification Updated Successfully!")
      setDisableOnResponse((prevDisableOnResponse) => ({
        ...prevDisableOnResponse,
        [notificationTypeId.notificationType]: false,
      }));
    } catch (error) {
      notify("error", "Update Notification Failed!")
      setDisableOnResponse((prevDisableOnResponse) => ({
        ...prevDisableOnResponse,
        [notificationTypeId.notificationType]: false,
      }));
    }
  }
  
  useEffect(() => {
    getAllUserNotificationPreferences()  
  }, [notificationsPreference])
  

  const NotificationsList = [
    <NotificationItem
      name="Events"
      toggleItem={
        <Switch
          disabled={disableOnResponse.events}
          design={SwitchDesignModes.NOTIFICATIONS_SWITCH}
          onChange={(e) => {handleNotificationSwitch(e, notificationTypes[1])}}
          state={getEmailOptionAnswer(notificationTypes[1]) ?? true}
        />
      }
    />,
    <NotificationItem
      name="Tutorials"
      toggleItem={
        <Switch
          disabled={disableOnResponse.tutorials}
          design={SwitchDesignModes.NOTIFICATIONS_SWITCH}
          onChange={(e) => handleNotificationSwitch(e, notificationTypes[2])}
          state={getEmailOptionAnswer(notificationTypes[2]) ?? true}
        />
      }
    />,
    <NotificationItem
      name="Connections"
      toggleItem={
        <Switch
          disabled={disableOnResponse.connections}
          design={SwitchDesignModes.NOTIFICATIONS_SWITCH}
          onChange={(e) => handleNotificationSwitch(e, notificationTypes[3])}
          state={getEmailOptionAnswer(notificationTypes[3]) ?? true}
        />
      }
    />,
    <NotificationItem
      name="Engagements"
      toggleItem={
        <Switch
          disabled={disableOnResponse.engagement}
          design={SwitchDesignModes.NOTIFICATIONS_SWITCH}
          onChange={(e) => handleNotificationSwitch(e, notificationTypes[4])}
          state={getEmailOptionAnswer(notificationTypes[4]) ?? true}
        />
      }
    />,
  ]
  const notificationsItems = [
    {
      name: NotificationsGroupItemName.EMAIL_NOTIFICATIONS,
      children: [<NotificationsPage children={NotificationsList} />]
    }
  ]


  return (
    <MainContainer
      inviteUsersByEmail={inviteUsersByEmail}
      stickTopBar
      stickyFooter
      title={`Welcome ${backendUser?.firstName} ${backendUser?.lastName}`}
      user={backendUser}
      showAvatar
    >
      <StyledEditProfileWrapper isDevice={isDevice}>
        <EditProfileDrawer icon={<StyledFilterIcon />} title={'Notifications'} parentItems={notificationsItems} />
      </StyledEditProfileWrapper>
    </MainContainer>
  )
}

export default observer(EditNotificationsPage)
